import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
    // State Objekt (z.B. gespeicherte Filter, Suchoptionen, Sortierungen etc.)
    state: {
        JourneyStore: [],
        JourneyStoreSingle: [],
        ContentStore: [],
        CountryStore: [],
        JourneyCountryStore: [],
        JourneyCategoryStore: [],
        Settings: {
            journeyoverview: {
                defaultsort: {
                    prop: 'date_from',
                    order: 'ascending'
                }
            }
        },
        bookingStates: [
            { name: "Buchbar", bookable: 1 },
            { name: "Auf Anfrage", bookable: 2 },
            { name: "Nicht Buchbar", bookable: 3 },
        ]
    },
    // Methoden um die States zu ändern (NICHT ASYNCHRON!)
    mutations: {
        listJourneys(state, data) {
            state.JourneyStore = data;
            state.JourneyStoreSingle = [];

            data.forEach(jrney => {
                try {
                    let cnts = JSON.parse(jrney.extras.find(jex => jex.type == 'Land').text)
                    cnts.forEach(cnt => {
                        if (!state.JourneyCountryStore.includes(cnt)) {
                            state.JourneyCountryStore.push(cnt)
                        }
                    });
                } catch (e) {
                    try {
                        if (!state.JourneyCountryStore.includes(jrney.extras.find(jex => jex.type == 'Land').text) && jrney.extras.find(jex => jex.type == 'Land').text !== "") {
                            state.JourneyCountryStore.push(jrney.extras.find(jex => jex.type == 'Land').text)
                        }
                    } catch (e) {}
                }

                jrney.dates.forEach(date => {
                    if(date.status == 1){
                        let _newJourney = JSON.parse(JSON.stringify(jrney))
                        _newJourney.dates = [date]
                        state.JourneyStoreSingle.push({
                            title: _newJourney.title,
                            date_from: date.date_from,
                            date_till: date.date_till,
                            einleitung: _newJourney.einleitung,
                            reisebeschreibung: _newJourney.reisebeschreibung,
                            duration: date.duration,
                            price: date.price,
                            id_jrn_journey: _newJourney.id_jrn_journey,
                            img: _newJourney
                        });
                    }
                })
            });
            state.JourneyStoreSingle = state.JourneyStoreSingle.sort((a, b) => a.date_from > b.date_from);
        },
        listContents(state, data) {
            state.ContentStore = data;
            core.emit("content-finished");
        },
        listCategories(state, data) {
            data = data.sort((a, b) => a.name > b.name)
            state.JourneyCategoryStore = data;
        },
        listCountries(state, data) {
            data = data.sort((a, b) => a.name > b.name)
            state.JourneyCountryStore = data;
        }
    },
    // Wenn Asynchrone Aktionen erfolgen, dann als action aufrufen, um die Mutation zu triggern
    actions: {
        listJourneys(context) {
            core.backend("jrn.listJourneysWeb", {
                id_acc_account: core.id_acc_account,
                page_size: 999
            }, (err, res) => {
                context.commit('listJourneys', res.data.rows);
            })
        },
        listContents(context) {
            core.backend("web.listContentsWeb", {
                id_acc_account: core.id_acc_account,
                page_size: 999
            }, (err, res) => {
                context.commit('listContents', res.data.rows);
            })
        },
        listCategories(context) {
            core.backend("jrn.listCategoriesWeb", {
                id_acc_account: core.id_acc_account,
                page_size: 999
            }, (err, res) => {
                context.commit('listCategories', res.data.rows);
            })
        },
        listCountries(context) {
            core.backend("jrn.listCountriesWeb", {
                id_acc_account: core.id_acc_account,
                page_size: 999
            }, (err, res) => {
                context.commit('listCountries', res.data.rows);
            })
        }
    },
    // Funktionen die im Zusammenhang mit State etwas returnen, z.B. wenn der State vorm holen noch behandelt werden muss
    getters: {}
})